import * as yup from 'yup'
import { mediaSchema } from '@/components/inputs'
import {
  OTHER_SPECIE_OPTION_VALUE,
  PHYSICAL_INSPECTION_BAT_SPECIE_VALUE,
} from '../fieldsOptions'

export const schema = yup.object({
  specie: yup.string().required(),
  other_specie: yup.string().when('specie', {
    is: OTHER_SPECIE_OPTION_VALUE,
    then: (schema) => schema.required(),
  }),
  specie_spec: yup
    .string()
    .required()
    .when('specie', {
      is: PHYSICAL_INSPECTION_BAT_SPECIE_VALUE,
      then: (schema) => schema.optional(),
    }),
  specie_spec_other: yup.string().when('specie_spec', {
    is: OTHER_SPECIE_OPTION_VALUE,
    then: (schema) => schema.required(),
  }),
  box_type: yup.string().required(),
  box_number: yup.string().required(),
  is_place_found: yup.string().required(),
  is_trail_found: yup.string().required(),
  orientation: yup.string().required(),
  height: yup.string().required(),
  notes: yup.string().max(256),
  observed_at: yup.date().required(),
  photos: mediaSchema,
})
